export const BLACK = "#000000"
export const WHITE = "#FFFFFF"
export const CREAM = "#FFF8EF"
export const BLUE = "#435D6E"
export const LIGHT_GRAY = "#CBD1D7"
export const DARK_GRAY = "#414448"
export const CONCRETE = "#71757A"
export const STONE = "#333333"
export const SAND = "#BFB7B4"
